import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=70bb1f80&"
import script from "./friends.js?vue&type=script&lang=js&"
export * from "./friends.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports